import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import AuthErrorHandler from '@/components/AuthErrorHandler';

export default function AuthError() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Log error details for debugging
    const errorParam = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');
    const errorCode = searchParams.get('code');

    console.error('Authentication Error:', {
      error: errorParam,
      description: errorDescription,
      code: errorCode,
      url: window.location.href,
      timestamp: new Date().toISOString(),
    });
  }, [searchParams]);

  return <AuthErrorHandler />;
}
